export const BuildInfo = {timestamp:1770938347000}
